// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"5551cef9","lsc":"6e70e11e","others":"2cccc60b"}[chunkId] + ".chunk.js";
};